/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["ja",[["åå","åå¾"]],u,[["æ¥","æ","ç«","æ°´","æ¨","é","å"],u,["æ¥ææ¥","æææ¥","ç«ææ¥","æ°´ææ¥","æ¨ææ¥","éææ¥","åææ¥"],["æ¥","æ","ç«","æ°´","æ¨","é","å"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["1æ","2æ","3æ","4æ","5æ","6æ","7æ","8æ","9æ","10æ","11æ","12æ"]],u,[["BC","AD"],["ç´åå","è¥¿æ¦"]],0,[6,0],["y/MM/dd",u,"yå¹´Mædæ¥","yå¹´Mædæ¥EEEE"],["H:mm","H:mm:ss","H:mm:ss z","Hæmmåssç§ zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","Â¤#,##0.00","#E0"],"JPY","ï¿¥","æ¥æ¬å",{"BYN":[u,"Ñ."],"CNY":["å","ï¿¥"],"JPY":["ï¿¥"],"PHP":[u,"â±"],"RON":[u,"ã¬ã¤"],"XXX":[]},"ltr", plural];
